import {
    Row,
    Col,
    Typography,
    Divider,
    Card,
    Button,
    Popconfirm,
    Select,
    Tag,
    Tooltip
  } from "antd";
import './MeetingCards.scss';
import { CloseOutlined,EditOutlined } from '@ant-design/icons';


const MeetingCards = ({data,onAction,...props}) => {

    const filterOption = (input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    }

    const tagRender = (props) => {
        const { label, value, closable, onClose } = props;

        return (
            <Tag
            style={{
                display: 'flex',
                alignItems: 'center',
                background: '#f5f5f5',
                borderRadius: '2px',
                padding: '2px 5px',
                marginRight: '4px',
            }}
            onClose={onClose}
        >
           <span style={{ display: 'flex', alignItems: 'center' }}>
                    {label}
                    <span
                        onMouseDown={(event) => event.stopPropagation()} 
                        // onClick={(event) => {
                        //     event.stopPropagation(); 
                        //     handleEditClick(value);
                        // }}
                        style={{ marginLeft: 5, cursor: 'pointer' }}
                    >
                        <Tooltip title={"Edit"}>
                        <EditOutlined />
                        </Tooltip>
                    </span>
                </span>
            <CloseOutlined 
                onClick={onClose}
                style={{ marginLeft: 5, cursor: 'pointer' }} 
            />
        </Tag>
        );
    }

    const handleOrganiserChange = (value, label, mode,type) => {
        onAction({
            value: value,
            label: label,
            mode: mode,
            type: 'handleOrganiserChange'
        })
    }


    const handleRequiredChange = (value,label,type) => {
        onAction({
            value: value,
            label: label,
            mode: null,
            type: 'handleRequiredChange'
        })
    }

    const handleOptionalChange = (value,label,type) => {
        onAction({
            value: value,
            label: label,
            mode: null,
            type: 'handleOptionalChange'
        })
    }

    const handleRequiredKOLChange = (value, label) => {
        onAction({
            value: value,
            label: label,
            mode: null,
            type: 'handleRequiredKOLChange'
        })       
    }


    const handleOptionalKOLChange = (value,label) => {
        onAction({
            value: value,
            label: label,
            mode: null,
            type: 'handleOptionalKOLChange'
        })
    }

    return(
        <div className="meeting-cards">
            <Row gutter={[10, 10]}>
                <Col xs={24} sm={24} md={24}>
                    <Card
                        title={
                            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <div>
                                    <a
                                        style={{ color: '#235D9F', fontWeight: '400', padding: '5px 0px' }}

                                    >
                                        <span>Arcuitis Attendees</span>
                                    </a>
                                </div>
                            </div>
                        }
                        style={{ border: '0.5px solid #EAEAEA' }}
                        styles={{
                            body: { padding: '0 10px 10px 10px' },
                            head: { borderBottom: '1px solid #EAEAEA' },
                        }}
                        bordered={false}
                    >
                        <Divider style={{ margin: '0 0 5px 0', borderWidth: '2px' }} />
                        <Row gutter={24} style={{ margin: '10px', }}>
                            <Col xs={8} sm={8} md={8}>
                                <p style={{ margin: 0, color: '#6A6D70', fontWeight: 'bolder' }}>Organiser&nbsp; </p>
                            </Col>
                            <Col xs={16} sm={16} md={16}>
                            <Select
                                    allowClear
                                    disabled={data?.arcutis_attendees?.organiser?.options?.length === 1 ? true : false}
                                    showSelectAll={true}
                                    style={{
                                        width: "100%",
                                    }}
                                    value={data?.arcutis_attendees?.organiser?.value}
                                    showSearch
                                    filterOption={filterOption}
                                    onChange={(value, keyLabels) => { handleOrganiserChange(value, keyLabels,"single") }}
                                    options={data?.arcutis_attendees?.organiser?.options}
                                >
                                </Select>
                            </Col>
                        </Row>
                        <Row gutter={24} style={{ margin: '10px', }}>
                            <Col xs={8} sm={8} md={8}>
                                <p style={{ margin: 0, color: '#6A6D70', fontWeight: 'bolder' }}>Required&nbsp; </p>
                            </Col>
                            <Col xs={16} sm={16} md={16}>
                                <Select
                                    allowClear
                                    disabled={data?.arcutis_attendees?.required?.options?.length === 1 ? true : false}
                                    showSelectAll={true}
                                    mode="multiple"
                                    style={{
                                        width: "100%",
                                    }}
                                    value={data?.arcutis_attendees?.required?.value}
                                    showSearch
                                    filterOption={filterOption}
                                    onChange={(value, label) => { handleRequiredChange(value, label) }}
                                    options={data?.arcutis_attendees?.required?.options}
                                >
                                </Select>
                            </Col>
                        </Row>
                        <Row gutter={24} style={{ margin: '10px', }}>
                            <Col xs={8} sm={8} md={8}>
                                <p style={{ margin: 0, color: '#6A6D70', fontWeight: 'bolder' }}>Optional&nbsp; </p>
                            </Col>
                            <Col xs={16} sm={16} md={16}>
                            <Select
                                    allowClear
                                    disabled={data?.arcutis_attendees?.optional?.options?.length === 1 ? true : false}
                                    showSelectAll={true}
                                    mode="multiple"
                                    style={{
                                        width: "100%",
                                    }}
                                    value={data?.arcutis_attendees?.optional?.value}
                                    showSearch
                                    filterOption={filterOption}
                                    onChange={(value, label) => { handleOptionalChange(value, label) }}
                                    options={data?.arcutis_attendees?.optional?.options}
                                >
                                </Select>
                            </Col>
                        </Row>
                    </Card>
                    <Card
                        title={
                            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <div>
                                    <a
                                        style={{ color: '#235D9F', fontWeight: '400', padding: '5px 0px' }}

                                    >
                                        <span>KOL Attendees</span>
                                    </a>
                                </div>
                            </div>
                        }
                        style={{ border: '0.5px solid #EAEAEA' }}
                        styles={{
                            body: { padding: '0 10px 10px 10px' },
                            head: { borderBottom: '1px solid #EAEAEA' },
                        }}
                        bordered={false}
                    >
                        <Divider style={{ margin: '0 0 5px 0', borderWidth: '2px' }} />
                        <Row gutter={24} style={{ margin: '10px', }}>
                            <Col xs={8} sm={8} md={8}>
                                <p style={{ margin: 0, color: '#6A6D70', fontWeight: 'bolder' }}>Organiser&nbsp; </p>
                            </Col>
                            <Col xs={16} sm={16} md={16}>
                                <Typography.Paragraph
                                    style={{ fontWeight: '500', marginBottom: 0, color: '#000000' }}
                                >
                                    No Organiser in KOL attendees
                                </Typography.Paragraph>
                            </Col>
                        </Row>
                        <Row gutter={24} style={{ margin: '10px', }}>
                            <Col xs={8} sm={8} md={8}>
                                <p style={{ margin: 0, color: '#6A6D70', fontWeight: 'bolder' }}>Required&nbsp; </p>
                            </Col>
                            <Col xs={16} sm={16} md={16}>
                                <Select
                                    allowClear
                                    disabled={data?.kol_attendees?.required?.options?.length === 1 ? true : false}
                                    showSelectAll={true}
                                    mode="multiple"
                                    style={{
                                        width: "100%",
                                    }}
                                    value={data?.kol_attendees?.required?.value}
                                    showSearch
                                    filterOption={filterOption}
                                    onChange={(value, label) => { handleRequiredKOLChange(value, label) }}
                                    options={data?.kol_attendees?.required?.options}
                                >
                                </Select>
                            </Col>
                        </Row>
                        <Row gutter={24} style={{ margin: '10px', }}>
                            <Col xs={8} sm={8} md={8}>
                                <p style={{ margin: 0, color: '#6A6D70', fontWeight: 'bolder' }}>Optional&nbsp; </p>
                            </Col>
                            <Col xs={16} sm={16} md={16}>
                            <Select
                                    allowClear
                                    disabled={data?.kol_attendees?.optional?.options?.length === 1 ? true : false}
                                    showSelectAll={true}
                                    mode="multiple"
                                    style={{
                                        width: "100%",
                                    }}
                                    value={data?.kol_attendees?.optional?.value}
                                    showSearch
                                    filterOption={filterOption}
                                    onChange={(value, label) => { handleOptionalKOLChange(value, label) }}
                                    options={data?.kol_attendees?.optional?.options}
                                >
                                </Select>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default MeetingCards;